const onboardItems = [
    { name: 'splash', path: '/app/welcome', isActive: false },
    { name: 'intro', path: '/app/welcome/intro', isActive: false },
    { name: 'third', path: '/app/welcome/learn', isActive: false },
    { name: 'closing', path: '/app/welcome/trial', isActive: false },
]

export default {
    methods: {
        getOnboardingItems(currPath: string) {
            let ret = []
            onboardItems.forEach((val) => {
                if (val.path == currPath) { 
                    val.isActive = true;
                } else {
                    val.isActive = false;
                }
                ret.push(val);
            });
            return ret
        }
    }
}